import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { MenuDivider } from '@sb/library/base';

@Component({
    selector: 'lib-chip-button-select-item',
    templateUrl: './chip-button-select-item.component.html',
    styleUrls: ['./chip-button-select-item.component.scss']
})
export class ChipButtonSelectItemComponent<T> {
    @Input() value!: T;
    @Input() menuDivider!: MenuDivider;

    @ViewChild('content', {static: true, read: TemplateRef}) content!: TemplateRef<any>;
}
